/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_SearchInputs */

const es_tools_drive_search = /** @type {(inputs: Tools_Drive_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscando en Google Drive...`)
};

const en_tools_drive_search = /** @type {(inputs: Tools_Drive_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Searching Google Drive...`)
};

/**
* | output |
* | --- |
* | "Searching Google Drive..." |
*
* @param {Tools_Drive_SearchInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_search = /** @type {((inputs?: Tools_Drive_SearchInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_SearchInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_search(inputs)
	return en_tools_drive_search(inputs)
});
export { tools_drive_search as "tools.drive.search" }